<template>
  <RouteProgressBar />
  <router-view />
</template>

<script setup>
import RouteProgressBar from '@/components/common/RouteProgressBar.vue';
</script>
